import { useTranslation } from 'react-i18next';

import { useUsd } from '@/hooks/useUsd';
import { EMPTY_VALUE } from '@/utils/placeholders';

import { styles } from './Costs.styles';
import type { ModelRowProps, ModelTableProps } from './Costs.types';
import { findPrice } from './Costs.utils';

const ModelRow = ({ model, price }: ModelRowProps) => {
	const usd = useUsd();

	return (
		<tr className={styles.tr}>
			<td className={styles.tdMono}>{model.model}</td>
			<td className={styles.tdRight}>{price ? usd.total(price.inputPerMTok) : EMPTY_VALUE}</td>
			<td className={styles.tdRight}>{price ? usd.total(price.outputPerMTok) : EMPTY_VALUE}</td>
			<td className={styles.tdRight}>{model.calls}</td>
			<td className={styles.tdRight}>{model.costUsd == null ? EMPTY_VALUE : usd.total(model.costUsd)}</td>
		</tr>
	);
};

export const ModelTable = ({ models, prices }: ModelTableProps) => {
	const { t } = useTranslation('translation', { keyPrefix: 'costs' });

	return (
		<div className={styles.tableWrap}>
			<table className={styles.table}>
				<thead className={styles.tableHead}>
					<tr>
						<th className={styles.th}>{t('COL_MODEL')}</th>
						<th className={styles.thRight}>{t('COL_INPUT_PRICE')}</th>
						<th className={styles.thRight}>{t('COL_OUTPUT_PRICE')}</th>
						<th className={styles.thRight}>{t('COL_CALLS')}</th>
						<th className={styles.thRight}>{t('COL_SPEND')}</th>
					</tr>
				</thead>
				<tbody>
					{models.map((model) => (
						<ModelRow key={model.model} model={model} price={findPrice(prices, model.model)} />
					))}
				</tbody>
			</table>
		</div>
	);
};
